import React, { useEffect } from "react";
import '../../../App.css';
import './Teambuilding.css';
import Footer from "../../Footer";
import useAutoplayVideo from "../../../hooks/useAutoplayVideo";

export default function Teambuilding() {
    const videoRef = useAutoplayVideo();

    useEffect(() => {
        document.title = 'Best Team Building Event in the Bay Area — Coffee Roasting | OFFF THE ROAST';
    }, []);

    return (
        <>
            {/* Hero Section */}
            <div className='tb-hero'>
                <video ref={videoRef} className='tb-hero-video tb-hero-video-desktop' src='/videos/team2.mp4' autoPlay loop muted playsInline preload="auto" />
                <img className='tb-hero-video tb-hero-video-mobile' src='/images/tb-hero-web.jpg' alt='Team building coffee roasting event' />

                <div className='tb-hero-content'>
                    <h1>TEAM BUILDING</h1>
                    <p>THE COFFEE ROASTING EXPERIENCE YOUR TEAM WON'T STOP TALKING ABOUT</p>
                    <a href='https://forms.gle/dp8ynVm2qVU8DR5m8' className='tb-hero-cta-btn' target='_blank' rel='noopener noreferrer'>
                        Click Me To Book
                    </a>
                </div>
            </div>

            {/* Intro Section */}
            <section className='tb-intro'>
                <div className='tb-section-container'>
                    <h2 className='tb-heading'>LOOKING FOR A TEAM-BUILDING EVENT THAT ACTUALLY STICKS?</h2>
                    <p className='tb-text'>
                        We provide a hands-on coffee roasting journey designed for teams that value craft, creativity, and genuine connection. This isn't just another corporate mixer—it's a deep dive into the art of coffee that gives your team serious bragging rights and a unique story to share long after the event ends.
                    </p>
                    <p className='tb-text'>
                        Having worked with teams from <span className='tb-highlight'>Google</span>, <span className='tb-highlight'>Meta</span>, <span className='tb-highlight'>Figure AI</span>, and many more, we specialize in delivering a premium, immersive experience for groups who want to step away from their screens and bond on a deeper level.
                    </p>
                </div>
            </section>

            {/* Booking Options Section */}
            <section className='tb-options'>
                <div className='tb-section-container'>
                    <h2 className='tb-section-title'>FLEXIBLE BOOKING TO FIT YOUR FLOW</h2>
                    <div className='tb-options-grid'>
                        <div className='tb-option-card'>
                            <h3>On-Site</h3>
                            <p>We bring all the professional equipment directly to your office. You just sit back, relax, and enjoy the craft.</p>
                        </div>
                        <div className='tb-option-card'>
                            <h3>Off-Site</h3>
                            <p>Join us at one of our beautiful partner cafés located throughout the San Jose and Santa Clara region.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Service Area Section */}
            <section className='tb-intro'>
                <div className='tb-section-container'>
                    <h2 className='tb-heading'>SERVING THE ENTIRE SF BAY AREA</h2>
                    <p className='tb-text'>
                        Based in San Jose, CA, we bring our coffee roasting team building experience to companies across the entire SF Bay Area — including San Francisco, Oakland, Palo Alto, Santa Clara, Sunnyvale, Mountain View, Cupertino, Fremont, Berkeley, and the greater Silicon Valley. Whether you need us at your office or want to host your team at our San Jose café, we make it seamless.
                    </p>
                    <p className='tb-text'>
                        Looking for a unique team building activity in San Francisco? A creative corporate event in Silicon Valley? A memorable group experience in the South Bay? Our coffee roasting sessions travel to you — no setup stress, just an unforgettable experience your team will talk about long after the last sip.
                    </p>
                </div>
            </section>

            {/* CTA Section */}
            <section className='tb-cta'>
                <div className='tb-section-container'>
                    <h2 className='tb-cta-heading'>Ready to roast?</h2>
                    <p className='tb-cta-text'>
                        <a href='https://forms.gle/dp8ynVm2qVU8DR5m8' className='tb-email-link' target='_blank' rel='noopener noreferrer'>Click Me To Book</a>
                    </p>
                    <p className='tb-cta-subtext'>We respond to all inquiries promptly to help you secure the perfect date and time for your team.</p>
                </div>
            </section>

            <Footer />
        </>
    );
}
